module.exports = __webpack_public_path__ + "static/img/knowdiabetes.b5245e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/knowdiabetes.png
// module id = 0XWP
// module chunks = 58